import getCookie from "../util/cookies";

function adminMarkReviewed(url,createdAt,success,fail) {
    fetch(
        (process.env.NODE_ENV === 'production' ? "https://api.recipes.bakerstlabs.io/admin/source-reviews/" : "https://dev-api.recipes.bakerstlabs.io/admin/source-reviews/") +
            encodeURIComponent(url) + "/" + createdAt,
        {headers: {
                'uid': getCookie("uid"),
                'auth': getCookie("auth")
            },method : 'DELETE'
        })
        .then(res => res.json())
        .then(
            (result) => {
               success(result)
            },
            (error) => {
                fail(error)
            }
        )
    }

export default adminMarkReviewed
